import { render, staticRenderFns } from "./tgbAvatar.vue?vue&type=template&id=6d6f3c80&scoped=true"
import script from "./tgbAvatar.vue?vue&type=script&lang=js"
export * from "./tgbAvatar.vue?vue&type=script&lang=js"
import style0 from "./tgbAvatar.vue?vue&type=style&index=0&id=6d6f3c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6f3c80",
  null
  
)

export default component.exports